<ng-container *ngIf="formControlName">
    <ng-container *ngIf="(inputConfig$ | async) as inputConfig">
        <ng-container *ngIf="!inputConfig.readOnly; else isReadOnly">
            <ng-container *ngIf="options$ | async as options">
                <p-treeSelect 
                name=formControlName 
                [options]="treeData"
                 [metaKeySelection]="false"
                    placeholder="Odaberite"
                     [filter]="true"
                      [filterInputAutoFocus]="true"
                    (onNodeSelect)="onNodeSelect($event)" 
                    (onClear)="clearSelection()" 
                    [(ngModel)]="selectedNodes" showClear="true"
                    [ngClass]="{ readonly: inputConfig.readOnly }" [disabled]="inputConfig.readOnly"></p-treeSelect>
            </ng-container>
            <ntap-show-form-errors [control]="formControl"></ntap-show-form-errors>
        </ng-container>
        <ng-template #isReadOnly>
            <ntap-input-label [data]="readonlyValue"></ntap-input-label>
        </ng-template>
    </ng-container>
</ng-container>